<template>
    <div>
        <Modal v-model="invoiceAccountModal.show"
            :width="600"
            :footer-hide="existsAccount"
            :title="'开票信息'">
            <Spin v-if="innerSpin"
                size="large"
                fix></Spin>
            <Row :gutter="16">
                <Col span="24">
                <Form ref="deliveryForm"
                    label-position="right"
                    :label-width="150">

                    <Row :gutter="16">
                        <Col span="24"
                            class-name="invoiceField">
                        <FormItem label="发票抬头:"
                            required>
                            <Input v-model="invoiceAccountModal.invoiceAccountBuyerName" :readonly="existsAccount"></Input>
                        </FormItem>
                        </Col>
                        <Col span="24"
                            class-name="invoiceField">
                        <FormItem label="统一社会信用代码:"
                            required>
                            <Input v-model="invoiceAccountModal.invoiceAccountBuyerTaxNum" :readonly="existsAccount"></Input>
                        </FormItem>
                        </Col>
                        <Col span="24"
                            class-name="invoiceField">
                        <FormItem label="开户银行名称:">
                            <Input v-model="invoiceAccountModal.invoiceAccountBuyerBank" :readonly="existsAccount"></Input>
                        </FormItem>
                        </Col>
                        <Col span="24"
                            class-name="invoiceField">
                        <FormItem label="基本开户账号:">
                            <Input v-model="invoiceAccountModal.invoiceAccountBuyerAccount" :readonly="existsAccount"></Input>
                        </FormItem>
                        </Col>
                        <Col span="24"
                            class-name="invoiceField">
                        <FormItem label="注册场所地址:">
                            <Input v-model="invoiceAccountModal.invoiceAccountBuyerAddress" :readonly="existsAccount"></Input>
                        </FormItem>
                        </Col>
                        <Col span="24"
                            class-name="invoiceField">
                        <FormItem label="注册固定电话:">
                            <Input v-model="invoiceAccountModal.invoiceAccountBuyerTel" :readonly="existsAccount"></Input>
                        </FormItem>
                        </Col>
                        <!-- <Col span="24"
                            class-name="invoiceField">
                        <FormItem label="营业执照:"
                            required>
                            <b-form-file @input="onSelectFile"
                                accept="image/*"
                                size="sm"
                                placeholder="未选择图片"
                                browse-text="选择"></b-form-file>
                        </FormItem>
                        </Col>

                        <Col v-if="invoiceAccountModal.tempImagePath"
                            span="24">
                        <FormItem label=" ">
                            <b-img style="width:50%"
                                center
                                :src="invoiceAccountModal.tempImagePath"></b-img>
                        </FormItem>
                        </Col> -->

                    </Row>
                </Form>
                </Col>
            </Row>

            <div slot="footer" v-if="!existsAccount">
                <Button type="primary"
                    @click="saveInvoiceAccount()">保存</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import api from '@/api/api';
import axios from 'axios';
import { formatDateTimeString, numberToFixed } from "@/libs/utils";
export default {
    name: "InvoiceinvoiceAccountModal",
    mounted() {
    },
    data() {
        return {
            innerSpin: false,
            invoiceAccountModal: {
                show: false,
                invoiceAccountUuid: '',
                invoiceAccountUserUuid: '',
                invoiceAccountBuyerName: '',
                invoiceAccountBuyerTaxNum: '',
                invoiceAccountBuyerBank: '',
                invoiceAccountBuyerAccount: '',
                invoiceAccountBuyerAddress: '',
                invoiceAccountBuyerTel: '',
                invoiceAccountLicenseImage: '',
                tempImagePath: '',
                invoiceAccountStatus: ''
            },
            existsAccount: true
        };
    },
    methods: {
        numberToFixed,
        showModal() {
            this.invoiceAccountModal.show = true;
            this.getInvoiceAccount();
        },
        getInvoiceAccount() {
            this.innerSpin = true;
            api.webGetInvoiceAccount().then(res => {
                this.innerSpin = false;
                if (res.code === 0) {
                    if (res.data.invoiceAccountModel) {
                        Object.assign(this.invoiceAccountModal, res.data.invoiceAccountModel);
                        if (this.invoiceAccountModal.invoiceAccountLicenseImage) {
                            let file = JSON.parse(this.invoiceAccountModal.invoiceAccountLicenseImage);
                            this.invoiceAccountModal.tempImagePath = api.fileServer + file.url;
                        }
                        else {
                            this.invoiceAccountModal.tempImagePath = '';
                        }
                        this.existsAccount = true
                    }
                    else {
                        this.existsAccount = false
                    }
                }
            });
        },
        saveInvoiceAccount() {
            this.innerSpin = true;
            api.webSaveInvoiceAccount(this.invoiceAccountModal).then(res => {
                this.innerSpin = false;
                if (res.code === 0) {
                    this.$bvModal.msgBoxOk("保存成功", {
                        title: '提示',
                        buttonSize: 'sm'
                    });
                    this.invoiceAccountModal.show = false;
                }
            });
        },
        onSelectFile(file) {
            let param = new FormData(); // 创建form对象
            param.append('file', file, file.name); // 通过append向form对象添加数据
            let config = {
                headers: { 'Content-Type': 'multipart/form-data' }
            };
            let that = this;
            axios.post(api.uploadFileAction, param, config)
                .then(response => {
                    let res = response.data;
                    if (res.code == 0) {
                        let firstFile = res.data.fileList[0];
                        that.invoiceAccountModal.invoiceAccountLicenseImage = JSON.stringify({
                            name: firstFile.fileName,
                            url: firstFile.fileUuid
                        });
                        that.invoiceAccountModal.tempImagePath = api.fileServer + 'upload/' + firstFile.fileUuid;
                    }
                });
        }



    }

};
</script>

<style>
.invoiceField {
    height: 40px;
}
</style>





// WEBPACK FOOTER //
// src/view/member/invoice-acount.vue